import { APIBase } from './APIBase.service';
import { Injectable } from '@angular/core';
import { OAuthRevokeResponse, OAuthToken } from '../../models/API.models';
import { Observable, firstValueFrom } from 'rxjs';
import { APIConfig, oAuthEndpointPath } from './API.config';
import { HttpParams } from '@angular/common/http';
import { oAuthConfig } from '../../../../environments/environment';

export interface IAPIAuthFlowService {
  authenticate(data: { [key: string]: string }): Observable<OAuthToken>;
  revoke(data: { [key: string]: string }): Observable<OAuthRevokeResponse>;
}

@Injectable({
  providedIn: 'root',
})
export class APIAuthFlowService extends APIBase implements IAPIAuthFlowService {
  apiConfig: APIConfig = {
    SERVER_PATH: oAuthConfig.domain,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };

  authenticate(data: { [key: string]: string }): Observable<OAuthToken> {
    const body = new HttpParams({ fromObject: data });
    return this.post<OAuthToken>(oAuthEndpointPath.token, body.toString());
  }

  revoke(data: { [key: string]: string }): Observable<OAuthRevokeResponse> {
    const body = new HttpParams({ fromObject: data });
    return this.post<OAuthRevokeResponse>(oAuthEndpointPath.revoke, body.toString());
  }
}
